var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "automation-block-editor number-formatter" },
    [
      _c(
        "div",
        { staticClass: "d-flex justify-content-between" },
        [
          _c("CustomPicker", {
            attrs: {
              items: _vm.formatTypes,
              idKey: "id",
              labelKey: "label",
              title: "Select Format",
            },
            model: {
              value: _vm.clone.mode,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "mode", $$v)
              },
              expression: "clone.mode",
            },
          }),
          _vm._v(" "),
          _vm.deleteEnabled
            ? _c(
                "SupsisButton",
                {
                  attrs: { danger: "", xxsmall: "" },
                  on: { click: _vm.deleteFormatter },
                },
                [_c("i", { staticClass: "material-icons" }, [_vm._v("delete")])]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.clone.mode === "math.random"
        ? _c("RandomNumber", {
            model: {
              value: _vm.clone,
              callback: function ($$v) {
                _vm.clone = $$v
              },
              expression: "clone",
            },
          })
        : [
            _c(
              "div",
              {
                staticClass: "editor-row customize-editor-minimize data-items",
              },
              [
                _c("div", { staticClass: "editor-row-title" }, [
                  _vm._v("Inputs"),
                ]),
                _vm._v(" "),
                _vm._l(_vm.clone.values, function (item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "d-flex gap-5" },
                    [
                      _c("TiptapEditor", {
                        attrs: {
                          placeholder: "Input Text",
                          "show-attributes": true,
                          "show-emoji": false,
                          "automation-mode": "",
                        },
                        model: {
                          value: _vm.clone.values[index],
                          callback: function ($$v) {
                            _vm.$set(_vm.clone.values, index, $$v)
                          },
                          expression: "clone.values[index]",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          attrs: { disabled: _vm.clone.values.length <= 1 },
                          on: {
                            click: function () {
                              return _vm.deleteInput(index)
                            },
                          },
                        },
                        [_vm._v(" sil ")]
                      ),
                    ],
                    1
                  )
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex flex-end w-100" },
              [
                !_vm.singleValueFormats.includes(_vm.clone.mode)
                  ? _c(
                      "SupsisButton",
                      { attrs: { primary: "" }, on: { click: _vm.addInput } },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("add"),
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v("Add Input")]),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }